import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Maintenance from '../pages/Maintenance'

const MaintenanceCheck = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        // Ne pas vérifier la maintenance pour les routes admin
        if (location.pathname.startsWith('/admin')) {
          setIsLoading(false)
          return
        }

        // Détection automatique de l'URL API
        const getApiUrl = () => {
          if (import.meta.env.VITE_API_URL) {
            return import.meta.env.VITE_API_URL
          }
          
          // En production, utiliser l'API publique
          if (typeof window !== 'undefined' && window.location.hostname === 'flightcasefwi.com') {
            return 'https://api.flightcasefwi.com/api'
          }
          
          // En développement, utiliser localhost (Docker: 3002)
          return 'http://localhost:3002/api'
        }
        
        const response = await fetch(`${getApiUrl()}/settings/public`)
        const data = await response.json()
        
        // Vérifier si la réponse indique une maintenance avec déconnexion
        if (data.maintenance_mode || (response.status === 503 && data.maintenance)) {
          // Si le flag disconnect est présent, déconnecter immédiatement
          if (data.disconnect) {
            localStorage.removeItem('user_token')
            localStorage.removeItem('admin_token')
            localStorage.removeItem('user')
            localStorage.removeItem('admin')
            localStorage.removeItem('cart')
          }
          // Vérifier si l'utilisateur est admin (après déconnexion éventuelle)
          const token = localStorage.getItem('user_token') || localStorage.getItem('admin_token')
          
          if (token) {
            try {
              // Décoder le token pour vérifier le rôle
              const payload = JSON.parse(atob(token.split('.')[1]))
              if (payload.role === 'admin') {
                // Admin autorisé, ne pas afficher la maintenance
                setIsMaintenanceMode(false)
              } else {
                // Utilisateur non-admin : afficher la maintenance
                setIsMaintenanceMode(true)
              }
            } catch (error) {
              // Token invalide, afficher la maintenance
              setIsMaintenanceMode(true)
            }
          } else {
            // Pas de token, afficher la maintenance
            setIsMaintenanceMode(true)
          }
        } else {
          setIsMaintenanceMode(false)
        }
      } catch (error) {
        console.error('Erreur lors de la vérification de la maintenance:', error)
        // En cas d'erreur, ne pas bloquer l'accès
        setIsMaintenanceMode(false)
      } finally {
        setIsLoading(false)
      }
    }

    checkMaintenance()
  }, [location.pathname])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    )
  }

  if (isMaintenanceMode) {
    return <Maintenance />
  }

  return children
}

export default MaintenanceCheck
